import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[tooltipSize]'
})
export class TooltipSizeDirective {
  @Input() tooltipSize: number | string | null = null;
  @Input() tooltipMinWidth: number | string | null = null;
  @Input() tooltipMaxWidth: number | string | null = null;

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {
  }

  @HostListener('mouseenter')
  @HostListener('focusin')
  onTooltipOpen(): void {
    requestAnimationFrame(() => this.applySizeToTooltip());
    setTimeout(() => this.applySizeToTooltip());
  }

  private applySizeToTooltip(): void {
    if (!this.tooltipSize && !this.tooltipMinWidth && !this.tooltipMaxWidth) {
      return;
    }

    const tooltip = this.findTooltipElement();

    if (!tooltip) {
      return;
    }

    tooltip.style.whiteSpace = 'normal';

    if (this.tooltipSize) {
      tooltip.style.width = `min(${this.normalizeCssSize(this.tooltipSize)}, calc(100vw - 2rem))`;
    }
    if (this.tooltipMinWidth) {
      tooltip.style.minWidth = this.normalizeCssSize(this.tooltipMinWidth);
    }
    if (this.tooltipMaxWidth) {
      tooltip.style.maxWidth = `min(${this.normalizeCssSize(this.tooltipMaxWidth)}, calc(100vw - 2rem))`;
    }
  }

  private findTooltipElement(): HTMLElement | null {
    const tooltipId = this.elementRef.nativeElement.getAttribute('aria-describedby');

    if (tooltipId) {
      return document.getElementById(tooltipId);
    }

    return document.querySelector('.tooltip[data-popper-placement]') as HTMLElement | null;
  }

  private normalizeCssSize(value: number | string): string {
    if (typeof value === 'number') {
      return `${value}px`;
    }

    const trimmedValue = value.trim();
    return /^\d+(\.\d+)?$/.test(trimmedValue) ? `${trimmedValue}px` : trimmedValue;
  }
}
